// extracted by mini-css-extract-plugin
module.exports = {"root":"terminal_root__N5Ykf","content":"terminal_content__3u_bq","items":"terminal_items__1RH84"};